import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { Fade } from 'react-awesome-reveal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadphones } from '@fortawesome/pro-solid-svg-icons/faHeadphones';
import { faFilterCircleDollar } from '@fortawesome/pro-solid-svg-icons/faFilterCircleDollar';
import { faCircleHeart } from '@fortawesome/pro-solid-svg-icons/faCircleHeart';
import { nextAsset } from '../../../../components/nextAsset';

export const SmartlinksDescriptionRelease: React.FC = () => {
  const intl = useIntl();
  return (
    <div style={{ position: 'relative' }} className="smartlinks-subpages-description">
      <Container>
        <Row className="pt-5">
          <Col xs={12} md={4} lg={3} className="d-flex align-items-center">
            <div className="d-none d-md-flex">
              <img
                src={nextAsset('images/smartLinks/home/iPhone17.png', false, { w: 900 })}
                className="img-fluid"
                alt="iphone17"
              />
            </div>
          </Col>
          <Col xs={12} md={1} lg={2} />
          <Col className="flex-column py-5">
            <h2 className="main-header pt-5 pb-3 text-white text-center text-md-start">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.release.directly.title',
                defaultMessage: 'Open your music directly in your listeners’ favorite music app'
              })}
            </h2>
            <p className="header-subtitle pb-4">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.release.feature.description.subtitle',
                defaultMessage:
                  'Reach your audience as efficiently as possible and maximize the impact of your release.'
              })}
            </p>
            <Row>
              <Col xs={12} lg={4} className="py-3">
                <Fade direction="up" triggerOnce className="h-100">
                  <div className="smartlinks-release-marketing-box">
                    <FontAwesomeIcon icon={faHeadphones} size="2x" />
                    <div>
                      <span className="text-white">
                        {intl.formatMessage({
                          id: 'sml.web.smartlinks.release.description.box1',
                          defaultMessage: 'Take your fans where they’re most willing to listen'
                        })}
                      </span>
                    </div>
                  </div>
                </Fade>
              </Col>
              <Col xs={12} lg={4} className="py-3">
                <Fade direction="up" triggerOnce className="h-100">
                  <div className="smartlinks-release-marketing-box">
                    <FontAwesomeIcon icon={faFilterCircleDollar} size="2x" />
                    <div>
                      <span className="text-white">
                        {intl.formatMessage({
                          id: 'sml.web.smartlinks.release.description.box2',
                          defaultMessage: 'Reduce drop-offs'
                        })}
                      </span>
                    </div>
                  </div>
                </Fade>
              </Col>
              <Col xs={12} lg={4} className="py-3">
                <Fade direction="up" triggerOnce className="h-100">
                  <div className="smartlinks-release-marketing-box">
                    <FontAwesomeIcon icon={faCircleHeart} size="2x" />
                    <div>
                      <span className="text-white">
                        {intl.formatMessage({
                          id: 'sml.web.smartlinks.release.description.box3',
                          defaultMessage: 'Build deeper connections with your fans'
                        })}
                      </span>
                    </div>
                  </div>
                </Fade>
              </Col>
            </Row>
            <div className="bg-subpages-waves">
              <img src={nextAsset('images/smartLinks/wave-subpages.svg')} alt="Background Waves" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
